var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CampingBanner'),_c('CampingAbout'),_c('CampingTypes'),_c('CampingLocation'),_c('ProductSalesSlide',{attrs:{"isCamping":true}}),_c('Clubs',{attrs:{"isCamping":true}}),_c('LandingValues')],1)}
var staticRenderFns = []

export { render, staticRenderFns }